import { gql } from '@apollo/client'

export const SET_COUPON_TEMPLATE = gql`
  mutation SetCouponTemplate($template: SetCampaignTemplateInput!) {
    setCampaignTemplate(input: $template)
  }
`
export const GET_COUPON = gql`
  query GetCoupon($couponId: ID!) {
    coupon(input: { id: $couponId }) {
      id
      code
      startsAt
      endsAt
      timezone
      discountType
      value
      channels
      constraints {
        passengerTypes {
          id
          name
          countryCode
        }
        limit
        minSale
        userLimit
        minTicketsCount
        salesChannelsV2 {
          id
          name
        }
        onlyRegisteredUsers
        bookingTypes
        departureDateRanges {
          from
          to
        }
        citySegments {
          destination {
            id
            name
            code
          }
          origin {
            id
            name
            code
          }
          segments {
            id
            destination {
              code
              id
              name
            }
            origin {
              code
              id
              name
            }
          }
        }
        confirmationModalities {
          paid
          reserved
        }
      }
      campaign {
        id
        name
        startsAt
        endsAt
        type
        company {
          id
          name
        }
      }
    }
  }
`
export const GET_COUPONS = gql`
  query GetCoupons($pagination: Pagination, $input: CouponsWithPaginationInput) {
    couponsWithPagination(pagination: $pagination, input: $input) {
      total
      items {
        id
        code
        campaign {
          id
          name
          company {
            id
            name
          }
        }
        startsAt
        endsAt
        isActive
        discountType
        value
        channels
        usedCount
        constraints {
          limit
          userLimit
          minSale
          citySegments {
            destination {
              id
              name
              code
            }
            origin {
              id
              name
              code
            }
            segments {
              id
              destination {
                code
                id
                name
              }
              origin {
                code
                id
                name
              }
            }
          }
        }
      }
    }
  }
`
export const GET_CAMPAIGNS_AUTOCOMPLETE = gql`
  query GetCampaignsAutocomplete($input: CampaignsAutocompleteInput) {
    campaignsAutocomplete(input: $input) {
      id
      name
    }
  }
`
export const GET_INCIDENCE_SUBCAMPAIGNS = gql`
  query GetIncidenceSubcampaigns($pagination: Pagination, $input: IncidenceSubcampaignsInput) {
    incidenceSubcampaigns(pagination: $pagination, input: $input) {
      total
      items {
        id
        reason
        authorizer
        startsAt
        endsAt
        coupons {
          usedCount
          startsAt
          endsAt
        }
        campaign {
          id
          name
          startsAt
          endsAt
          type
          area
          company {
            id
            name
          }
        }
        trip {
          id
          origin {
            name
          }
          destination {
            name
          }
          legSegments {
            origin {
              name
            }
            destination {
              name
            }
          }
        }
      }
    }
  }
`

export const GET_DATABASE_SUBCAMPAIGNS = gql`
  query GetDatabaseSubcampaigns($pagination: Pagination, $input: DatabaseSubcampaignsInput) {
    databaseSubcampaigns(pagination: $pagination, input: $input) {
      total
      items {
        id
        name
        startsAt
        endsAt
        coupons {
          usedCount
          startsAt
          endsAt
        }
        campaign {
          id
          name
          startsAt
          endsAt
          type
          area
          company {
            id
            name
          }
        }
      }
    }
  }
`

export const GET_INCIDENCE_SUBCAMPAIGN = gql`
  query GetIncidenceSubcampaign($id: ID!) {
    incidenceSubcampaign(input: { id: $id }) {
      id
      campaignID
      status
      startsAt
      endsAt
    }
  }
`

export const GET_DATABASE_SUBCAMPAIGN = gql`
  query GetDatabaseSubcampaign($id: ID!) {
    databaseSubcampaign(input: { id: $id }) {
      id
      campaignID
      status
      startsAt
      endsAt
    }
  }
`

export const GET_DB_COUPONS_SUBCAMPAIGN = gql`
  query GetSubcampaignCoupons($input: DatabaseSubcampaignCouponsInput!, $pagination: Pagination) {
    databaseSubcampaignCoupons(pagination: $pagination, input: $input) {
      total
      coupons {
        id
        status
        isActive
        user {
          email
          phone
          name
        }
        emails {
          id
          updatedAt
          status
        }
        supportInteractions {
          notificationChannel
          callStatus
          notes
          createdAt
          user {
            username
          }
        }
      }
    }
  }
`

export const GET_CAMPAIGNS = gql`
  query GetCampaigns($name: String) {
    campaigns(input: { limit: 10000, name: $name }) {
      id
      name
      type
      area
      startsAt
      endsAt
      timezone
      isActive
      description
      template {
        prefix
      }
      subCampaigns {
        id
      }
      company {
        id
        name
      }
      coupons {
        startsAt
        endsAt
        isActive
      }
    }
  }
`
export const GET_CAMPAIGN_COUPON_TEMPLATE = gql`
  query GetCampaign($campaignId: ID!) {
    campaign(input: { id: $campaignId }) {
      id
      name
      type
      template {
        prefix
        salesChannelsV2 {
          id
          name
        }
        value
        confirmationModalities {
          paid
          reserved
        }
        expirationTime {
          value
          unit
        }
      }
    }
  }
`
